<template>
  <DataListStateful
    title="Подвижной состав"
    resource="rolling-stocks"
    :columns="columns"
    store="rollingStocks"
    :filter-options="filter"
  />
</template>

<script>
export default {
  data() {
    return {
      columns: [
        { title: "Ид", name: "id", sortable: false },
        { title: "Наименование", name: "title", sortable: true },
        { title: "Тип", name: "type", dataPath: "Type.Title" },
        { title: "Объем", name: "volume", sortable: true },
        { title: "Грузоподъемность", name: "carryingCapacity", sortable: true },
      ],
      filter: {
        title: {
          title: "Наименование",
          type: "text",
        },
        rollingStockType: {
          title: "Тип",
          type: "reference",
          resource: "rolling-stock-types",
        },
        volume: {
          title: "Объем",
          type: "decimal",
        },
        carryingCapacity: {
          title: "Грузоподъемность",
          type: "decimal",
        },
      },
    };
  },
};
</script>
